<svelte:head>
  <title>Disconnected | A Good Thing</title>
</svelte:head>

<section class="section hero">
  <div class="hero-body">
    <div class="container">
      <div class="columns is-centered">
        <div class="column is-two-fifths">
          <div class="card has-card-header-background">
            <header class="card-header">
              <p class="card-header-title">
                <!-- svelte-ignore a11y-missing-attribute -->
                <a href="https://www.agoodthing.org.uk/">
                  <img src="/assets/img/logo_h.png" />
                </a>
              </p>
            </header>
            <div class="card-content">
              <h2 class="title">Uh oh.</h2>
              <h2 class="title">
                Your firewall may be blocking access to A Good Thing.
              </h2>
              <p>
                Contact <a href="mailto:support@agoodthing.org.uk"
                  >support@agoodthing.org.uk</a> for assistance.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<script lang="ts">
  import { ga } from '@beyonk/svelte-google-analytics';
  import { logging } from '$lib/logging';

  let email: string, password: string, errorMessage: string | undefined;

  let isLoading = false;

  function login() {
    errorMessage = undefined;

    isLoading = true;

    window.firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then(() => {
        ga.addEvent('login', {});
      })
      .catch((err) => {
        errorMessage = err.message;
        ga.addEvent('error_login', { message: err.message });
        logging.setUser(email); // user has not succesfully logged on, but tag the error with the user id
        logging.report(new Error(err.message, { cause: err }));
      })
      .finally(() => {
        isLoading = false;
      });
  }
</script>
